// extracted by mini-css-extract-plugin
module.exports = {"classes":"Classes_classes__1JV5x","filters":"Classes_filters__REtBW"};